export default {
  flock_copyright: 'Flock FZ LLC',
  read_release_notes: 'Read release notes',
};



// WEBPACK FOOTER //
// ./src/components/Modal/AboutFlockModal/I18n/es.js